import { render, staticRenderFns } from "./WvSteakHouseSteakItem.vue?vue&type=template&id=15b6af95&scoped=true"
import script from "./WvSteakHouseSteakItem.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseSteakItem.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseSteakItem.vue?vue&type=style&index=0&id=15b6af95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b6af95",
  null
  
)

export default component.exports